export default __webpack_public_path__ + "img/cSsUohWA.4805c4b1.svg";